import { PublicSpotifyArtist } from 'src/Redux/publicSpotifyArtistsApi'

export const MAX_TRACK_NAME_LENGTH = 255

export const getSpotifyArtistUrl = (artistSpotifyId: string): string =>
  `https://open.spotify.com/artist/${artistSpotifyId}`

export const getSpotifyArtistId = (searchInputValue: string): string => {
  const match = searchInputValue.match(/artist\/([a-zA-Z0-9]{22})/)
  return match ? match[1] : ''
}

export const getIsCreateCampaignEnabled = (
  selectedArtist: PublicSpotifyArtist | null,
  trackName: string,
): boolean => {
  const trimmedTrackName = trackName.trim()

  return (
    Boolean(selectedArtist) &&
    trimmedTrackName.length > 0 &&
    trimmedTrackName.length <= MAX_TRACK_NAME_LENGTH
  )
}
